/**
 * App entry point for the targeted support frontend application.
 * This is a simple wrapper that imports and renders the main application component.
 */
import "@financial-advisory/ui/components/pdf-viewer/src/style/pdf-viewer.css";
import { AppRouter } from "./AppRouter";

export default function App() {
  return <AppRouter />;
}
